var render, staticRenderFns
import script from "./ClSvgIcon.ts?vue&type=script&lang=ts&"
export * from "./ClSvgIcon.ts?vue&type=script&lang=ts&"
import style0 from "./ClSvgIcon.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports